<template>
  <div class="home-reports">
    <Row :gutter="8">
      <Col :lg="24" style="margin-top: 8px">
        <Card shadow style="height: 140px" :title="`服务器数量（总数：${serverCount.total}）`">
          <div>
            <Spin fix v-show="serverCount.loading"></Spin>
            <Alert type="error" v-if="serverCount.error" show-icon>获取数据失败</Alert>
            <div id="bar_server_type_id" style="width: 100%; height: 60px;" v-else></div>
          </div>
        </Card>
      </Col>
      <Col :lg="24" style="margin-top: 8px">
        <Card shadow style="height: 140px" :title="`云主机操作系统统计`">
          <div>
            <Spin fix v-show="serverOsCount.loading"></Spin>
            <Alert type="error" v-if="serverOsCount.error" show-icon>获取数据失败</Alert>
            <div id="bar_server_os_id" style="width: 100%; height: 60px;" v-else></div>
          </div>
        </Card>
      </Col>
      <Col :lg="12" style="margin-top: 8px">
        <Card shadow style="height: 300px" :title="`云主机平台统计`">
          <Spin fix v-show="platform.loading"></Spin>
          <Alert type="error" v-if="platform.error" show-icon>获取数据失败</Alert>
          <div id="pie_platform_server_id" style="width: 100%; height: 230px;" v-else></div>
        </Card>
      </Col>
      <Col :lg="12" style="margin-top: 8px">
        <Card shadow style="height: 300px" title="云主机账号统计" class="no-padding-card-body">
          <div>
            <Alert type="error" v-if="accountCount.error" show-icon style="margin: 16px;">获取数据失败</Alert>
            <Table
              v-else
              :columns="accountCount.columns"
              :data="accountCount.data"
              max-height="265"
              size="small"
              :loading="accountCount.loading"></Table>
          </div>
        </Card>
      </Col>
      <Col :lg="12" style="margin-top: 8px">
        <Card shadow style="height: 300px" class="no-padding-card-body">
          <p slot="title">
            <span>云主机地域统计</span>
            <Select size="small" style="float: left; width: 150px; padding-left: 5px" v-model="regionCount.platform" @on-change="getServerRegionData">
              <Option v-for="item in platformList" :key="item.value" :value="item.value">{{ item.label }}</Option>
            </Select>
          </p>
          <div>
            <Alert type="error" v-if="regionCount.error" show-icon style="margin: 16px;">获取数据失败</Alert>
            <Table
              v-else
              :columns="regionCount.columns"
              :data="regionCount.data"
              max-height="265"
              size="small"
              :loading="regionCount.loading"></Table>
          </div>
        </Card>
      </Col>
      <Col :lg="12" style="margin-top: 8px">
        <Card shadow style="height: 300px" class="no-padding-card-body">
          <p slot="title">
            <span>即将过期云主机（总数：<a style="color: red" v-on:click="$router.push({name: 'server_manage'})">{{ expiringCount.data.length }}</a>）</span>
          </p>
          <div>
            <Alert type="error" v-if="expiringCount.error" show-icon style="margin: 16px;">获取数据失败</Alert>
            <Table
              v-else
              :columns="expiringCount.columns"
              :data="expiringCount.data"
              max-height="265"
              size="small"
              :loading="expiringCount.loading"></Table>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { getServerType, getServerOs, getServerPlatform, getServerAccount, getServerRegion, getServerExpire } from '@/api/opscenter'
import echarts from '@/view/monitor/components/echarts-use.js'

export default {
  name: 'server',
  data () {
    return {
      // 平台列表
      platformList: [
        { value: 1, label: '阿里云' },
        { value: 2, label: 'UCloud' },
        { value: 3, label: '亚马逊云' },
        { value: 8, label: '华为云' }
      ],
      // 按物理机/云主机统计
      serverCount: {
        total: 0,
        loading: false,
        error: false
      },
      serverTypeBarOption: {
        xAxis: {
          type: 'value',
          show: false
        },
        yAxis: {
          type: 'category',
          show: false,
          axisTick: {
            show: false
          }
        },
        series: [{
          type: 'bar',
          name: '物理机',
          data: [],
          stack: 'income',
          barWidth: 13,
          label: {
            normal: {
              show: true,
              position: 'left',
              // TODO
              offset: [40, -20],
              formatter: '{a} {c}'
            }
          },
          itemStyle: {
            normal: {
              color: '#f86676',
              barBorderRadius: [5, 0, 0, 5]
            }
          }
        }, {
          type: 'bar',
          name: '云主机',
          data: [],
          stack: 'income',
          barWidth: 13,
          label: {
            normal: {
              show: true,
              position: 'left',
              // TODO
              offset: [40, 20],
              formatter: '{a} {c}'
            }
          },

          itemStyle: {
            normal: {
              color: '#14b9f6',
              barBorderRadius: [0, 5, 5, 0]

            }

          }
        }]
      },
      // 按操作系统统计
      serverOsCount: {
        loading: false,
        error: false
      },
      serverOsBarOption: {
        xAxis: {
          type: 'value',
          show: false
        },
        yAxis: {
          type: 'category',
          show: false,
          axisTick: {
            show: false
          }
        },
        series: [{
          type: 'bar',
          name: 'Linux',
          data: [],
          stack: 'income',
          barWidth: 13,
          label: {
            normal: {
              show: true,
              position: 'left',
              // TODO
              offset: [40, -20],
              formatter: '{a} {c}'
            }
          },
          itemStyle: {
            normal: {
              color: '#f888f0',
              barBorderRadius: [5, 0, 0, 5]
            }
          }
        }, {
          type: 'bar',
          name: 'Windows',
          data: [],
          stack: 'income',
          barWidth: 13,
          label: {
            normal: {
              show: true,
              position: 'left',
              // TODO
              offset: [40, 20],
              formatter: '{a} {c}'
            }
          },
          itemStyle: {
            normal: {
              color: '#f6903b',
              barBorderRadius: [0, 5, 5, 0]
            }
          }
        }]
      },
      // 按平台统计
      platform: {
        pieOption: {
          title: {
            show: false
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: [],
            show: false
          },
          series: [
            {
              name: '平台',
              type: 'pie',
              radius: '55%',
              center: ['50%', '60%'],
              data: [],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              label: {
                normal: {
                  formatter: '{b|{b}：}{c}  {per|{d}%}\n  ',
                  rich: {
                    a: {
                      color: '#999',
                      lineHeight: 15,
                      align: 'center'
                    },
                    b: {
                      fontSize: 12
                    },
                    per: {
                      color: '#eee',
                      backgroundColor: '#334455',
                      padding: [2, 4],
                      borderRadius: 2
                    }
                  }
                }
              }
            }
          ]
        },
        error: false,
        loading: false
      },
      // 按账号统计
      accountCount: {
        error: false,
        loading: false,
        columns: [
          { title: '账号', key: 'username', align: 'center' },
          { title: '平台', key: 'registrar', align: 'center' },
          { title: '云主机总数', key: 'total', align: 'center' },
          {
            title: '即将过期数',
            key: 'expire_num',
            align: 'center',
            render: (h, params) => {
              return h('span', {
                style: {
                  color: 'red'
                }
              }, params.row.expire_num)
            }
          }
        ],
        data: []
      },
      // 按地域统计
      regionCount: {
        platform: null,
        error: false,
        loading: false,
        columns: [
          { title: '地域', key: 'region', align: 'center' },
          { title: '云主机数量', key: 'total', align: 'center' },
          {
            title: '即将过期数',
            key: 'expire_num',
            align: 'center',
            render: (h, params) => {
              return h('span', {
                style: {
                  color: 'red'
                }
              }, params.row.expire_num)
            }
          }
        ],
        data: []
      },
      // 即将过期
      expiringCount: {
        error: false,
        loading: false,
        columns: [
          {
            title: '云主机',
            key: 'name',
            align: 'center',
            render: (h, params) => {
              let name = params.row.name
              if (!name) {
                name = 'null'
              }
              return h('router-link', {
                props: {
                  to: {
                    name: 'server_detail',
                    query: { id: params.row.id }
                  }
                }
              }, name)
            }
          },
          { title: '公网IP', key: 'public_ip', align: 'center' },
          { title: '平台', key: 'platform', align: 'center' },
          { title: '所属账号', key: 'account', align: 'center' },
          {
            title: '到期时间',
            key: 'time_expire',
            align: 'center',
            render: (h, params) => {
              return h('span', {
                style: {
                  color: 'red'
                }
              }, params.row.time_expire)
            }
          }
        ],
        data: []
      }
    }
  },
  created: function () {
    this.getServerTypeData()
    this.getServerOsData()
    this.getPlatformData()
    this.getExpiringServerCount()
    this.getAccountCount()

    this.regionCount.platform = this.platformList[0].value
    this.getServerRegionData()
  },
  methods: {
    // 按物理机/云主机统计
    getServerTypeData () {
      this.serverCount.loading = true
      this.serverCount.error = false
      getServerType().then(res => {
        this.serverCount.total = res.data.data.asset_count + res.data.data.cloud_count
        this.serverTypeBarOption.series[0].data = [res.data.data.asset_count]
        this.serverTypeBarOption.series[1].data = [res.data.data.cloud_count]
        let chart = echarts.init(document.getElementById('bar_server_type_id'), 'roma')
        window.addEventListener('resize', function () {
          chart.resize()
        })
        chart.clear()
        chart.setOption(this.serverTypeBarOption, true)
        this.serverCount.loading = false
      }).catch(res => {
        this.serverCount.loading = false
        this.serverCount.error = true
        console.error(res)
      })
    },
    // 按操作系统统计
    getServerOsData () {
      this.serverOsCount.loading = true
      this.serverOsCount.error = false
      getServerOs().then(res => {
        this.serverOsBarOption.series[0].data = [res.data.data.linux]
        this.serverOsBarOption.series[1].data = [res.data.data.windows]
        let chart = echarts.init(document.getElementById('bar_server_os_id'), 'roma')
        window.addEventListener('resize', function () {
          chart.resize()
        })
        chart.clear()
        chart.setOption(this.serverOsBarOption, true)
        this.serverOsCount.loading = false
      }).catch(res => {
        this.serverOsCount.loading = false
        this.serverOsCount.error = true
        console.error(res)
      })
    },
    // 按平台统计
    getPlatformData () {
      this.platform.error = false
      this.platform.loading = true
      getServerPlatform().then(res => {
        this.platform.pieOption.legend.data = res.data.data.map(item => item.registrar)
        this.platform.pieOption.series[0].data = res.data.data.map(item => {
          return {name: item.registrar, value: item.total}
        })
        let domainPlatformPie = echarts.init(document.getElementById('pie_platform_server_id'), 'roma')
        window.addEventListener('resize', function () {
          domainPlatformPie.resize()
        })
        domainPlatformPie.clear()
        domainPlatformPie.setOption(this.platform.pieOption, true)
        this.platform.loading = false
      }).catch(res => {
        this.platform.loading = false
        this.platform.error = true
        console.error(res)
      })
    },
    // 按账号统计
    getAccountCount () {
      let params = {
        time: 30
      }
      this.accountCount.error = false
      this.accountCount.loading = true
      getServerAccount(params).then(res => {
        this.accountCount.loading = false
        this.accountCount.data = res.data.data
      }).catch(res => {
        this.accountCount.loading = false
        this.accountCount.error = true
        console.error(res)
      })
    },
    // 按地域
    getServerRegionData () {
      let params = {
        platform: this.regionCount.platform
      }
      this.regionCount.error = false
      this.regionCount.loading = true
      getServerRegion(params).then(res => {
        this.regionCount.loading = false
        this.regionCount.data = res.data.data
      }).catch(res => {
        this.regionCount.loading = false
        this.regionCount.error = true
        console.error(res)
      })
    },
    // 即将过期
    getExpiringServerCount () {
      let params = {
        ordering: 'time_expire',
        time: 30
      }
      this.expiringCount.error = false
      this.expiringCount.loading = true
      getServerExpire(params).then(res => {
        this.expiringCount.loading = false
        this.expiringCount.data = res.data.data
      }).catch(res => {
        this.expiringCount.loading = false
        this.expiringCount.error = true
        console.error(res)
      })
    }
  }
}
</script>

<style scoped>

</style>
